var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 9.875c0-5.232 4.23-9.5 9.5-9.5 5.232 0 9.5 4.268 9.5 9.5 0 5.27-4.268 9.5-9.5 9.5a9.47 9.47 0 0 1-9.5-9.5m13.768-1.633a1.01 1.01 0 0 0 0-1.447 1.01 1.01 0 0 0-1.448 0l-4.008 4.008-1.67-1.633a1.01 1.01 0 0 0-1.447 0 1.01 1.01 0 0 0 0 1.447l2.375 2.375c.409.408 1.04.408 1.448 0z"
  })));
};
export default SvgVerified;